import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import Carousel from "react-material-ui-carousel";
// import SaleBanner from "../components/SaleBanner";

const Home = () => {
  // State for handling modal visibility and selected item
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // const calculateDiscountedPrice = (price) => {
  //   const numericPrice = parseFloat(price.replace("ksh", "").replace(",", ""));
  //   const discountedPrice = numericPrice * 0.8; 
  //   return `ksh ${discountedPrice.toFixed(2)}`;
  // };

  // Handle modal open/close
  const handleOpen = (item) => {
    setSelectedItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedItem(null);
    setOpen(false);
  };

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          top: 0,
          left: 0,
          width: "98.9vw", // Full viewport width
          height: { xs: "50vh", sm: "60vh", md: "80vh" }, // Full viewport height
          minHeight: "50vh",
          backgroundImage: "url(/home.jpg)",
          backgroundColor: "lavenderblush",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflow: "hidden", // Ensure no overflow
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          color: "black",
          textAlign: "center",
          // zIndex: -1, // Ensure it's behind other content
        }}
      >
        <Box
          sx={{ marginTop: { xs: "5rem", md: "10rem" }, textAlign: "center" }}
        >

          <Typography
            variant="h1"
            gutterBottom
            sx={{ fontSize: { xs: "3rem", md: "8rem" } }}
          >
            Whimssical Stitches!
          </Typography>
          <Typography
            variant="h4"
            gutterBottom
            sx={{ fontSize: { xs: "1rem", md: "2rem" } }}
          >
            Crafted with threads of Elegance.
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to="/shop"
            sx={{
              marginTop: "2rem",
              padding: { xs: "8px 16px", sm: "10px 20px", md: "auto" },
              fontSize: { xs: "0.7rem", sm: "1rem", md: "auto" },
              width: { xs: "25%", sm: "30%", md: "auto" },
              backgroundColor: "#1c0a49",
              "&:hover": { backgroundColor: "#d75efb" },
            }}
          >
            Shop Now
          </Button>
        </Box>
      </Box>

      <Container sx={{ padding: "2rem 0" }}>
        {/* Why Whimssical Section */}
        <Grid
          container
          spacing={3}
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                High Quality
              </Typography>
              <Typography variant="body2">
                We use only the finest materials to ensure durability and
                comfort.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                Unique Designs
              </Typography>
              <Typography variant="body2">
                Our products feature one-of-a-kind designs you won't find
                anywhere else.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Box sx={{ textAlign: "center" }}>
              <Typography variant="h5" gutterBottom>
                Exceptional Service
              </Typography>
              <Typography variant="body2">
                We pride ourselves on providing top-notch customer support and
                service.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Featured Products Section */}
        <Box
          sx={{ marginTop: "4rem", marginBottom: "2rem", textAlign: "center" }}
        >
          <Typography variant="h3" gutterBottom>
            Featured Products
          </Typography>
          <Typography variant="body1" gutterBottom>
            Explore our carefully curated selection of featured items. From cozy
            blankets to intricate scarves, each piece is a testament to our
            commitment to quality and design. Each stich tell a story and
            portrays the crocheters love, care and willingness to create
            perfection just for you.
          </Typography>

          <Grid container spacing={3} justifyContent="center" padding={8}>
            {[
              {
                name: "Scarf",
                price: "ksh 2000.00",
                img: "scarf.jpg",
                relatedImages: [
                  "scarf.jpg",
                  "https://i.etsystatic.com/20390955/r/il/533c78/2468039171/il_794xN.2468039171_se51.jpg",
                  "https://i.etsystatic.com/8271146/r/il/77ec5c/2740901724/il_794xN.2740901724_ijvh.jpg",
                ],
                link: "/shop",
              },
              {
                name: "Sweater",
                price: "ksh 4500",
                img: "/cable.webp",
                relatedImages: [
                  "cable1.webp",
                  "https://i.etsystatic.com/18940880/r/il/1ecb85/3820768801/il_794xN.3820768801_ks9v.jpg",
                  "https://i.etsystatic.com/18940880/r/il/ec6fba/3773172684/il_794xN.3773172684_jx7i.jpg",
                ],
                link: "/shop",
              },
              {
                name: "Shorts",
                price: "ksh 1500.00",
                img: "/shorts.jpg",
                relatedImages: [
                  "shorts.jpg",
                  "https://i.etsystatic.com/47890228/r/il/340895/5900442878/il_794xN.5900442878_t8n9.jpg",
                  "https://i.etsystatic.com/47890228/r/il/18bd09/5764626450/il_794xN.5764626450_cafo.jpg",
                ],
                link: "/shop",
              },
              {
                name: "Tank Top",
                price: "ksh 1500.00",
                img: "https://i.etsystatic.com/34201462/r/il/213f95/3796292139/il_794xN.3796292139_n92j.jpg",
                relatedImages: [
                  "https://i.etsystatic.com/34201462/r/il/213f95/3796292139/il_794xN.3796292139_n92j.jpg",
                  "https://i.etsystatic.com/34201462/r/il/a6975e/3796292541/il_794xN.3796292541_kgvh.jpg",
                  "https://i.etsystatic.com/34201462/r/il/ccc86c/3748700822/il_794xN.3748700822_hqey.jpg",
                ],
                link: "/shop",
              },
              {
                name: "Balaclava",
                price: "ksh 2000.00",
                img: "Balaclava.webp",
                relatedImages: [
                  "Balaclava.webp",
                  "https://i.etsystatic.com/30227477/r/il/234663/4531693733/il_794xN.4531693733_8xoc.jpg",
                  "https://i.etsystatic.com/30227477/r/il/26d5e3/4484328292/il_794xN.4484328292_2c3m.jpg",
                ],
                link: "/shop",
              },
            ].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.name}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardMedia
                    component="img"
                    height="170"
                    image={item.img}
                    alt={item.name}
                    sx={{ objectFit: "cover", cursor: "pointer" }}
                    onClick={() => handleOpen(item)} // Open modal on click
                  />
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {item.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.price}
                    </Typography>
                  </CardContent>
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    href={item.link}
                    sx={{
                      margin: "0 1rem 1rem",
                      backgroundColor: "#1c0a49",
                      "&:hover": { backgroundColor: "#d75efb" },
                    }}
                  >
                    Shop Now
                  </Button>
                </Card>
              </Grid>
            ))}
          </Grid>
          {/* Popup Dialog for image preview */}
          <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogContent>
              <Box position="relative">
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    zIndex: 1,
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <CloseIcon />
                </IconButton>
                {selectedItem && (
                  <Carousel>
                    {selectedItem.relatedImages.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`${selectedItem.name} - ${idx + 1}`}
                        style={{ width: "100%", height: "auto" }}
                      />
                    ))}
                  </Carousel>
                )}
              </Box>
              {selectedItem && (
                <Box mt={2}>
                  <Typography variant="h6" gutterBottom>
                    {selectedItem.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {selectedItem.price}
                  </Typography>
                </Box>
              )}
            </DialogContent>
          </Dialog>
        </Box>

        {/* Discover More Section */}
        {/* <Box
          sx={{ marginTop: "4rem", marginBottom: "2rem", textAlign: "center" }}
        >
          <Typography variant="h3" gutterBottom>
            Discover More Items
          </Typography>
          <Typography variant="body1" gutterBottom>
            Uncover new and exciting additions to our collection. Whether you're
            looking for something specific or just browsing, you're sure to find
            something that catches your eye.
          </Typography>

          <Grid container spacing={3} padding={8}>
            {[
              {
                name: "Winter Collection",
                img: "/shop5.jpg",
                link: "/shop/winter",
              },
              {
                name: "Summer Vibes",
                img: "/shop6.jpg",
                link: "/shop/summer",
              },
              {
                name: "Autumn Arrivals",
                img: "/shop7.jpg",
                link: "/shop/autumn",
              },
              {
                name: "Spring Essentials",
                img: "/shop8.jpg",
                link: "/shop/spring",
              },
              { name: "New In", img: "/shop4.jpg", link: "/shop/newin" },
            ].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.name}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardMedia
                    component="img"
                    height="140"
                    image={item.img}
                    alt={item.name}
                  />
                  <CardContent>
                    <Typography variant="h6" component="div">
                      {item.name}
                    </Typography>
                  </CardContent>
                  <Button
                    size="small"
                    color="primary"
                    href={item.link}
                    sx={{ margin: "0 1rem 1rem" }}
                  >
                    Shop Now
                  </Button>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box> */}
      </Container>
    </Box>
  );
};

export default Home;
